import fetch from "../connector";
import { PATH_API_HELI, PATH_BASE_URL } from "../../../components/pages/App/constants";
import { ARTICLES, GENERATE_PAYMENT, SAVE_PAYMENT, getPathSummary, HEADER_PAYMENT_REQUEST } from "./constants";

export const getArticles = () =>
  fetch(PATH_BASE_URL, ARTICLES, {
    method: "GET",
  });

export const generatePaymentRequest = (data) =>
  fetch(PATH_API_HELI, GENERATE_PAYMENT, {
    method: "POST",
    headers: HEADER_PAYMENT_REQUEST,
    data: data,
  });

export const savePayment = (data) =>
  fetch(PATH_BASE_URL, SAVE_PAYMENT, {
    method: "POST",
    data: data,
  });

export const getPaymentSummary = (id) =>
  fetch(PATH_BASE_URL, getPathSummary(id), {
    method: "GET",
  });
